import { toNumber } from 'lodash';

import { SORT_ORDER } from '@common/types';
import useSidebarStore from '../../../../../../store/sideBarStore.store.ts';

export type NoteType =
  'Email' | 'Phone call' | 'Reflection' | 'Text' | 'Other' | '';

export type CareNotesColumnNames =
  | 'program'
  | 'note_type'
  | 'last_updated_at'
  | 'recorded_minutes'
  | 'created_by_name'
  | 'note';

export interface ICareNotesTableFilters {
  sort_by: CareNotesColumnNames;
  sort_order: SORT_ORDER;
  page: number;
  limit: number;
  note_type?: NoteType;
  program_id?: string;
  provider_id?: string;
  user_id?: string;
}

export interface ICareNotesTableEntries {
  id: string;
  program: string;
  note_type: string;
  last_updated_at: string;
  recorded_minutes: number;
  created_by_name: string;
  note: string;
  notable_call: boolean;
  provider: string | null;
}

interface IUseCareNotesTableProps {
  filters: ICareNotesTableFilters;
  setFilters: (filters: ICareNotesTableFilters) => void;
}

export const useCareNotesTable = ({
  filters,
  setFilters,
}: IUseCareNotesTableProps) => {
  const { sort_by, sort_order } = filters;
  const { isSidebarOpen } = useSidebarStore();

  const notesMaxWidth = `calc(100vw - ${isSidebarOpen ? 800 : 650}px)`;

  const handleChangeOrder = (colName: CareNotesColumnNames) => {
    setFilters({
      ...filters,
      sort_by: colName,
      sort_order: filters.sort_order === 'asc' ? 'desc' : 'asc',
    });
  };

  const onPageIndexChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number,
  ) => {
    setFilters({ ...filters, page: page + 1 });
  };

  const onPageSizeChange = (event: {
    target: {
      value: string;
    };
  }) => {
    setFilters({ ...filters, limit: toNumber(event.target.value), page: 1 });
  };

  return {
    sort_by,
    sort_order,
    onPageIndexChange,
    onPageSizeChange,
    handleChangeOrder,
    notesMaxWidth,
  };
};
